import { useEffect, useRef, useState } from "react";
import { toast } from "sonner";
import { api, errText } from "../lib/api";

const PASS = ["category", "province", "q", "city", "sort", "verified", "min_price", "max_price"];

export const buildListingQuery = (params, page) => {
  const query = new URLSearchParams();
  PASS.forEach((k) => { const v = params.get(k); if (v && v !== "all") query.set(k, v); });
  if (params.get("category") === "lost-found" && params.get("lf") && params.get("lf") !== "all") query.set("lf_type", params.get("lf"));
  if (params.get("radius") && params.get("near")) { query.set("radius", params.get("radius")); query.set("near", params.get("near")); }
  query.set("page", String(page));
  query.set("per_page", "24");
  return query.toString();
};

// Keeps the previous results on screen while new ones load and drops stale responses
export function useBrowseListings(params, page) {
  const [state, setState] = useState({ items: [], total: 0, pages: 1, didYouMean: "", sort: "" });
  const [loading, setLoading] = useState(true);
  const [loaded, setLoaded] = useState(false);
  const ctrl = useRef(null);
  const key = buildListingQuery(params, page);

  useEffect(() => {
    ctrl.current?.abort();
    const c = new AbortController();
    ctrl.current = c;
    setLoading(true);
    api.get(`/listings?${key}`, { signal: c.signal })
      .then(({ data }) => setState({ items: data.items, total: data.total, pages: data.pages, didYouMean: data.did_you_mean || "", sort: data.sort || "" }))
      .catch((err) => {
        if (c.signal.aborted) return;
        setState({ items: [], total: 0, pages: 1, didYouMean: "", sort: "" });
        toast.error(err?.response?.status === 400 ? errText(err) : "Couldn't load listings. Please try again.", { id: "browse-load-error" });
      })
      .finally(() => { if (!c.signal.aborted) { setLoading(false); setLoaded(true); } });
    return () => c.abort();
  }, [key]);

  return { ...state, loading, firstLoad: loading && !loaded };
}
